module.exports = __webpack_public_path__ + "static/media/emily-addison-lose.8f4e0871.jpg";